import { Inject, Injectable } from '@angular/core';
import { WINDOW_TOKEN } from './bootstrap.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(@Inject(WINDOW_TOKEN) private browserWindow: Window) {
  }

  /**
   * getCurrentLocation
   * Returns the current browser window location
   *
   * @return
   */
  getCurrentLocation(): Location {
    return this.browserWindow.top !== undefined ? this.browserWindow.top.location : this.browserWindow.location;
  }

  /**
   * Return application's location -  current url minus hash and search string
   */
  getIndexPageUrl(): string {
    const windowLocation = this.getCurrentLocation();
    return `https://${windowLocation.host}${windowLocation.pathname}`;
  }

  getHash(): string {
    return this.getCurrentLocation().hash;
  }

  getSearch(): string {
    return this.getCurrentLocation().search;
  }
}
